<template>
<div id="container">
   <div class="locationWrap download">
     <div>
       <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
       <strong class="inner locTit aniBox type_bot gogo">
         <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>다운로드
       </strong>
     </div>
   </div>
   <div class="contents">
     <div class="inner">
       <div class="subTitWrap aniBox type_left gogo">
         <h2>자료실</h2>
       </div>

       <h3 class="subTxt">Damda 자료실입니다.</h3>

       <form name="frm_search" @submit.prevent="loadData(1)">
       <div class="topSearchArea clearfix">
         <div class="topSearch clearfix">
           <select name="search_field" id="searchField" class="select_ty1" v-model="searchOpt.keyType">
             <option value="01">전체</option>
             <option value="02">제목</option>
             <option value="03">유형</option>
           </select>
           <div class="inputBox">
             <input type="text" class="input_ty1" name="search_keyword" value="" v-model="searchOpt.keyWord" >
             <input type="button" class="btn_search" value="" @click="loadData(1) ">
           </div>
         </div>
       </div>
       </form>

       <div class="tblArea aniBox type_bot gogo">
         <table class="tbl_ty1">
           <colgroup>
              <col width="20%">
              <col width="*">
              <col width="20%">
              <col width="20%">
           </colgroup>
           <thead>
             <tr>
              <th class="num">유형</th>
              <th class="title">제목</th>
              <!-- <th class="title">내용</th> -->
              <th class="date">등록일</th>
              <th class="date">수정일</th>
            </tr>
           </thead>
           <tbody>
             <tr v-for="item in gridData" v-bind:key="item.keyid">
               <!-- 모달로 띄울때 -->
               <!-- <td class="titleU"><a href="javascript:" @click="openMtpView(item)" v-text="item.title"></a></td>
               <td class="title text-left" @click="openMtpView(item)" v-text="item.contents"></td> -->
               
               <!-- 페이지 이동 -->
               <td v-text="categoryNm(item.category)"></td>
               <td class="titleU"><a href="javascript:" @click="goDetail(item.keyid)" v-text="item.title"></a></td>
               <!-- <td class="title text-left" @click="goDetail(item.keyid)" v-text="item.contents"></td> -->
               <td class="date" v-text="dateFmt(item.regDate)"></td>
               <td class="date" v-text="dateFmt(item.updateDate)"></td>
             </tr>
             <tr v-if="gridData.length===0">
              <td colspan="4">
                <div class="searchNothing">
                  <img src="/static/images/contents/icon_info.png" alt="">
                  <p>조회결과가 없습니다..</p>
                </div>
              </td>
             </tr>
           </tbody>
         </table>
       </div>

       <paginate
        v-model="pageNo" v-if="pageInfo.finalPageNo"
        :page-count="pageInfo.finalPageNo"
        :page-range="10"
        :click-handler="loadData"
        :prev-text="'〈'"
        :prev-link-class="'first'"
        :next-text="'〉'"
        :next-class="'last'"
        :page-link-class="'text-white'"
        :container-class="'paging'">
      </paginate>
      <!-- <modals-container  /> -->
     </div>
   </div>
 </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import VuejsPaginate from 'vuejs-paginate'

export default {
  name: 'DownloadVue',
  data () {
    return {
      gridData: [],
      pageInfo: [],
      pageNo: 1,
      countPerPage: 10,
      searchOpt: {
        keyWord: '',
        keyType: '01'
      }
    }
  },
  components: {
    'paginate': VuejsPaginate
  },
  methods: {
    dateFmt (dt) {
      return moment(dt).format('YYYY-MM-DD')
    },
    loadData (no) {
      var _this = this
      var params = {
        pageNo: no || 1,
        countPerPage: _this.countPerPage,
        keyType: _this.searchOpt.keyType,
        keyWord: _this.searchOpt.keyWord
      }
      axios.get('/web/api/board/TES', { withCredentials: true, params: params })
        .then(response => {
          if (response.data.result) {
            _this.gridData = response.data.result
          } else {
            _this.gridData = []
          }
          _this.pageInfo = response.data.page
        })
        .catch(e => {
          alert('페이지를 올바르게 구성하지 못하였습니다. 잠시후에 이용해주세요')
          console.log('error : ', e)
        })
    },
    categoryNm (id) {
      if (id === 'TEMP1') {
        return '웨비나'
      } else if (id === 'TEMP2') {
        return '다운로드'
      } else if (id === 'TEMP3') {
        return '기사ㆍ동향'
      } else {
        return id
      }
    },
    // 모달
    // openMtpView: function (mtp) {
    //   this.$modal.show(MTemplateView, {
    //     viewmtp: mtp,
    //     modal: this.$modal }, {
    //     name: 'mtpView',
    //     width: '600px',
    //     height: 'auto',
    //     maxHeight: 600,
    //     draggable: false,
    //     adaptive: true,
    //     resizable: true,
    //     scrollable: true
    //   })
    // },
    // 페이지 이동
    goDetail (no) {
      //alert('no : ', no)
      this.$router.push('/download/Vue/' + no)
    }
  },
  created () {
  },
  computed: {
  },
  mounted () {
    this.loadData()
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
tbody .download a {
  padding: 0 5px;
}
.paging li >>> a {
  color: #fff;
}
tr td {
  text-align : center;
}
.titleU a {
  text-decoration: none;
}
.titleU a:hover {
  text-decoration: underline;
}
.text-left {
  text-align : left;
}

</style>



// WEBPACK FOOTER //
// src/components/DownloadVueTest.vue